import { v4 as uuidv4 } from "uuid";
export class DesignationModel {
    constructor() {
        this.id = uuidv4();
        this.designationName = "";
    }
}
export default class Designation extends DesignationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
